const groupPrefix = createApiRoute(ApiModule.SYSTEM, ApiDataModel.SCHEDULE_BLACKLIST)

export const apiOperationBlacklist = {
	fetchOrderScheduleLimitations: async (): Promise<IOrderScheduleLimitationListModel> => {
		const { data } = await apiCommon<IOrderScheduleLimitationList>(`${groupPrefix}`, { method: 'GET' })

		return OrderScheduleBlacklistList(data)
	},

	createOrderScheduleLimitation: async (
		payload: IOrderScheduleLimitationCreate,
	): Promise<IOrderScheduleLimitationModel> => {
		const { data } = await apiCommon<IOrderScheduleLimitation>(`${groupPrefix}`, {
			method: 'POST',
			body: OrderScheduleLimitationToJson(payload),
		})

		return OrderScheduleBlacklistItem(data)
	},

	deleteOrderScheduleLimitation: async (dayID: number) =>
		await apiCommon<string>(`${groupPrefix}/${dayID}`, {
			method: 'DELETE',
		}),
}
